import { LogGroup } from ".././MyHelpers";
import { MultigameParams2 } from "../MultigameParams2";
import { MultigameParams21 } from "../MultigameParams21";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage } from "../ResourceManager/ResourceManager";
import { Resourceful2 } from "../ResourceManager/Resourceful";
import { ScreenProtocol } from "../ScreenProtocol";
import { SlotGameInitData } from "../SlotGameInitData";

export abstract class SlotGame21 implements Resourceful2
{
	public name: string = "";
	public index: number = 0;

	protected features: string[] = [];

	protected initData: SlotGameInitData = null;
	protected logGroup: LogGroup = null;

	protected screenProtocol: ScreenProtocol = null;

	public basepath: string;

	public constructor(initData: SlotGameInitData, multigameParams: MultigameParams21) {
		this.name = initData.GameName;
		this.index = initData.Index;
		this.initData = initData;
		this.features = initData.Feature;
		//this.clientState = multigameParams.clientState;

		this.screenProtocol = multigameParams.screenProtocol;
		this.logGroup = new LogGroup(["Slot21", this.name]);
	}

	public async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
	}

	public async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
	}

	public abstract Update(): void;
	public abstract View(): HTMLElement;
	//public abstract Spin(): void;
	//public abstract OnSpinResult(spinResult: SlotSpinResult): void;

	//public abstract Bonus(): SlotBonus;

	// public abstract SelectLine(lineIndex:number): void;
	// public abstract SelectDenom(denomIndex:number): void;
	// public abstract SelectBet(betIndex: number): void;

	public abstract GameSelected(): void;
	public abstract GameExit(): void;

	public abstract HasPresentation(): boolean;


	// public abstract GetSelectedLineIndex(): number;
	// public abstract GetSlectedDenomIndex(): number;

	// public abstract GetPreview(): HTMLElement;

	public abstract AnimationStopRequest(): void;
	public abstract AnimationStartRequest(): void;

}
